import { render, staticRenderFns } from "./icare_detail.vue?vue&type=template&id=7e2e0fc8&"
import script from "./icare_detail.vue?vue&type=script&lang=js&"
export * from "./icare_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports